
export class DataNavigationState {
    selectedView = 'respondents';// respondents , stats
    respondentsView = 'by-synchro';// one-by-one, by-synchro
    paginationNumber = 0;
    respondentId = 0;
    synchroId = 0;  // this refers to a deviceID since a synchro abstraction is always associated to a device
    selectedQuestionnaire = 'No Questionnaire Selected';
}


